import type {RouterConfig} from '@nuxt/schema';
import {normalizeHashSelector} from '~/utils/scrollToSection';

function normalizeRouteHash(hash: string): string | undefined {
	if (!hash) {
		return undefined;
	}

	const normalizedHash = normalizeHashSelector(hash);
	return normalizedHash === '#' ? undefined : normalizedHash;
}

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
	scrollBehavior: (to, from, savedPosition) => {
		const nuxtApp = useNuxtApp();
		const normalizedToHash = normalizeRouteHash(to.hash);

		if (!normalizedToHash && savedPosition) {
			return savedPosition;
		}

		if (from.path === to.path && normalizedToHash) {
			return new Promise((resolve) => {
				const performScroll = async () => {
					await scrollToSection(normalizedToHash);
					resolve(false);
				};
				performScroll();
			});
		}

		return new Promise((resolve) => {
			nuxtApp.hooks.hookOnce('page:finish', () => {
				const performScroll = async () => {
					await new Promise((_resolve) => setTimeout(_resolve, 100));

					if (normalizedToHash) {
						await scrollToSection(normalizedToHash);
						resolve(false);
					} else {
						resolve({top: 0, left: 0});
					}
				};
				performScroll();
			});
		});
	},
};
